<template>
  <label v-if="intents.length > 1" class="intent-picker">
    <select :value="modelValue" class="intent-picker-select" @change="handleChange">
      <option v-for="candidateIntent in intents" :key="candidateIntent.id" :value="candidateIntent.id">
        {{ formatIntentOption(candidateIntent) }}
      </option>
    </select>
  </label>
</template>

<script setup lang="ts">
import type { SparkIntent } from '@/core/data/spark/spark.interface';
import { format, isToday, isTomorrow } from 'date-fns';

interface IntentDaySelectProps {
  intents: SparkIntent[];
  modelValue: string;
}

defineProps<IntentDaySelectProps>();

const emit = defineEmits<(event: 'update:modelValue', value: string) => void>();

function handleChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  emit('update:modelValue', value);
}

function formatIntentOption(intent: SparkIntent) {
  if (isToday(intent.date)) return 'Today';
  if (isTomorrow(intent.date)) return 'Tomorrow';

  return format(new Date(intent.date), 'EEE, MMM d');
}
</script>

<style lang="scss" scoped>
.intent-picker {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  gap: 4px;
  border: 1px solid var(--color-pink);
  border-radius: 21px;
  padding: 6px 6px;
  backdrop-filter: blur(8px);
}

.intent-picker-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  background: none;
  border: 0;
  outline: none;
  box-shadow: none;
  font: inherit;
  color: inherit;

  width: 100%;
  max-width: 180px;
  color: var(--color-white);
  background: transparent;
  border: none;
  padding: 2px 6px;
  font-size: 13px;

  text-align: center;
  text-align-last: center;
  -moz-text-align-last: center;
}
</style>
